/* tslint:disable */
/* eslint-disable */
/**
 * MG-DX Pharmacy API
 * API for Pharmacy
 *
 * The version of the OpenAPI document: 0.2.0
 * Contact: developers@mg-dx.co.jp
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { tzDate } from "@mgdx-libs/dayjs";
import { exists, mapValues } from "../runtime";

export const PutPharmacyCounselingBoothResponseTypename = "PutPharmacyCounselingBoothResponse" as const;

/**
 *
 * @export
 * @interface PutPharmacyCounselingBoothResponse
 */
export interface PutPharmacyCounselingBoothResponse {
  /**
   *
   * @type {number}
   * @memberof PutPharmacyCounselingBoothResponse
   */
  counselingBoothCount?: number;
  /**
   *
   * @type {string}
   * @memberof PutPharmacyCounselingBoothResponse
   */
  counselingBoothName?: string;
  /**
   * Resource type name
   * @type {string}
   * @memberof PutPharmacyCounselingBoothResponse
   */
  readonly __typename?: string;
}

export function PutPharmacyCounselingBoothResponseFromJSON(json: any): PutPharmacyCounselingBoothResponse {
  return PutPharmacyCounselingBoothResponseFromJSONTyped(json, false);
}

export function PutPharmacyCounselingBoothResponseFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): PutPharmacyCounselingBoothResponse {
  if (json === undefined || json === null) {
    return json;
  }
  return {
    __typename: PutPharmacyCounselingBoothResponseTypename,

    counselingBoothCount: !exists(json, "counseling_booth_count") ? undefined : json["counseling_booth_count"],
    counselingBoothName: !exists(json, "counseling_booth_name") ? undefined : json["counseling_booth_name"],
  };
}

export function PutPharmacyCounselingBoothResponseToJSON(object?: PutPharmacyCounselingBoothResponse | null): any {
  if (object === undefined) {
    return undefined;
  }
  if (object === null) {
    return null;
  }
  const { __typename, ...value } = object;
  return {
    counseling_booth_count: value.counselingBoothCount,
    counseling_booth_name: value.counselingBoothName,
  };
}
